import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=8ce87110&scoped=true&"
import script from "./Explain.vue?vue&type=script&lang=ts&"
export * from "./Explain.vue?vue&type=script&lang=ts&"
import style0 from "./Explain.vue?vue&type=style&index=0&id=8ce87110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce87110",
  null
  
)

export default component.exports